module.exports = __webpack_public_path__ + "img/83_1.d29e417c.jpg";